import React from 'react';
import styles from './TabsContent.module.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

export const DuoUniPlusDescription = () => {

  return (
    <div className={styles.container}>
      <p className={styles.mainTitle}>Cazanele <span className={styles.highlight}>Duo Uni Plus </span></p>
      <p className={styles.text}>
        Cazanele DUO UNI Plus sunt cazane cu combustibil solid care ard foarte mult timp. Cazanele sunt destinate încălzirii caselor, spațiilor municipale și industriale. Gama de putere: 15-250 kW.
      </p>
      <p className={styles.text}>
        În regimul complet de bază, funcționarea cazanului este posibilă în modul de încărcare manuală a combustibilului solid. Pentru a pune în funcțiune centrala în modul automat de alimentare cu combustibil, este necesar să instalați suplimentar ușa sub arzătorul cu peleți, arzătorul în sine și buncărul de combustibil. Cazanul are grătar din fontă (15-40 kW) sau grilă cu apă (50-250 kW). Sistemul de alimentare cu aer multi-canal asigură o ardere de lungă durată și uniformă a combustibilului de sus în jos. Acest avantaj vă permite să utilizați diferite tipuri de combustibil, diferite dimensiuni și fracții.
      </p>
      <p className={styles.text}>
        Prin dimensiunile sale compacte, cazanul are o suprafață mare de suprafață de convecție, ceea ce oferă un nivel ridicat de eficiență și economisește semnificativ consumul de combustibil.
      </p>
      <p className={styles.text}>
        Cazanele DUO UNI Plus sunt echipate cu un ventilator și o unitate de control pentru automatizarea funcționării cazanului.
      </p>
      <h1 className={styles.title}>Caracteristicile cazanului</h1>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Parametri</th>
              <th>U.M.</th>
              <th colSpan="11">Duo UNI PLUS</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Puterea nominală a cazanului</td>
              <td>kW</td>
              <td>21</td>
              <td>27</td>
              <td>33</td>
              <td>40</td>
              <td>50</td>
              <td>62</td>
              <td>75</td>
              <td>95</td>
              <td>120</td>
              <td>150</td>
              <td>200</td>
            </tr>
            <tr>
              <td>Suprafața schimbătorului de căldură</td>
              <td>m²</td>
              <td>1,9</td>
              <td>2,3</td>
              <td>2,6</td>
              <td>3,1</td>
              <td>3,6</td>
              <td>4,5</td>
              <td>5,0</td>
              <td>6,0</td>
              <td>8,0</td>
              <td>9,3</td>
              <td>10,2</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="13">Dimensiunea camerei de ardere</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Adâncime</td>
              <td>mm</td>
              <td>400</td>
              <td>450</td>
              <td>450</td>
              <td>520</td>
              <td>600</td>
              <td>600</td>
              <td>650</td>
              <td>740</td>
              <td>820</td>
              <td>950</td>
              <td>1050</td>
            </tr>
            <tr>
              <td>Volum</td>
              <td>dm³</td>
              <td>68</td>
              <td>77</td>
              <td>97</td>
              <td>122</td>
              <td>140</td>
              <td>220</td>
              <td>260</td>
              <td>307</td>
              <td>488</td>
              <td>566</td>
              <td>626</td>
            </tr>
            <tr>
              <td>Volumul apei din cazan</td>
              <td>l</td>
              <td>84</td>
              <td>92</td>
              <td>105</td>
              <td>120</td>
              <td>135</td>
              <td>170</td>
              <td>194</td>
              <td>220</td>
              <td>290</td>
              <td>328</td>
              <td>357</td>
            </tr>
            <tr>
              <td>Greutate uscată</td>
              <td>kg</td>
              <td>320</td>
              <td>340</td>
              <td>380</td>
              <td>420</td>
              <td>460</td>
              <td>680</td>
              <td>720</td>
              <td>790</td>
              <td>1070</td>
              <td>1160</td>
              <td>1250</td>
            </tr>
            <tr>
              <td>Temperatura gazelor arse</td>
              <td>°C</td>
              <td colSpan="11">100-180</td>
            </tr>
            <tr>
              <td>Temperatura apei min. recomandată</td>
              <td>°C</td>
              <td colSpan="11">58</td>
            </tr>
            <tr>
              <td>Temperatura max. a apei</td>
              <td>°C</td>
              <td colSpan="11">90</td>
            </tr>
            <tr>
              <td>Presiunea nominală de lucru a apei</td>
              <td>MPa</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,15</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
              <td>0,20</td>
            </tr>
            <tr>
              <td>Consum curent electric, max</td>
              <td>W</td>
              <td>85</td>
              <td>85</td>
              <td>85</td>
              <td>85</td>
              <td>105</td>
              <td>160</td>
              <td>160</td>
              <td>160</td>
              <td>175</td>
              <td>175</td>
              <td>205</td>
            </tr>
            <tr>
              <td>Diametru racord coș</td>
              <td>mm</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
              <td>178</td>
              <td>219</td>
              <td>248</td>
              <td>248</td>
              <td>248</td>
              <td>298</td>
              <td>298</td>
              <td>298</td>
            </tr>
            <tr>
              <td>Diametru țevi racordare rețea apă</td>
              <td>mm</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>50</td>
              <td>65</td>
              <td>65</td>
              <td>80</td>
              <td>80</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th colSpan="13">Dimensiune recomandată burlan</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Secțiunea transversală</td>
              <td>cm²</td>
              <td>201</td>
              <td>201</td>
              <td>248</td>
              <td>248</td>
              <td>377</td>
              <td>452</td>
              <td>452</td>
              <td>452</td>
              <td>660</td>
              <td>660</td>
              <td>660</td>
            </tr>
            <tr>
              <td>Diametru intern</td>
              <td>mm</td>
              <td>160</td>
              <td>160</td>
              <td>180</td>
              <td>180</td>
              <td>220</td>
              <td>250</td>
              <td>250</td>
              <td>250</td>
              <td>300</td>
              <td>300</td>
              <td>300</td>
            </tr>
            <tr>
              <td>Înălțime (minim permisă)</td>
              <td>m</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>5</td>
              <td>6</td>
              <td>6</td>
              <td>6</td>
              <td>7</td>
              <td>7</td>
              <td>7</td>
              <td>8</td>
            </tr>
            <tr>
              <td>Diametrul țevii de sub siguranțele supapei (Du)</td>
              <td>mm</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>15</td>
              <td>20</td>
              <td>20</td>
              <td>20</td>
              <td>25</td>
              <td>25</td>
              <td>50</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const DuoUniPlusDimensions = () => {
  return (
    <div className={styles.dimensionsContainer}>
      <div className={styles.imageContainer}>
        <img src="/Dimensions/ClassicPlusSchemaAuto.png" alt="Descriptive Alt Text" className={styles.centeredImage} />
      </div>
      <div className={styles.tableContainer}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Dimensiuni automatizat</th>
              <th>U.M.</th>
              <th>21 kW</th>
              <th>27 kW</th>
              <th>33 kW</th>
              <th>40 kW</th>
              <th>50 kW</th>
              <th>62 kW</th>
              <th>75 kW</th>
              <th>95 kW</th>
              <th>120 kW</th>
              <th>150 kW</th>
              <th>200 kW</th>
              <th>250 kW</th>
              <th>300 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>B</td>
              <td>mm</td>
              <td>610</td>
              <td>610</td>
              <td>660</td>
              <td>660</td>
              <td>660</td>
              <td>790</td>
              <td>790</td>
              <td>790</td>
              <td>880</td>
              <td>880</td>
              <td>960</td>
              <td>1070</td>
              <td>1270</td>
            </tr>
            <tr>
              <td>B1</td>
              <td>mm</td>
              <td>510</td>
              <td>510</td>
              <td>560</td>
              <td>560</td>
              <td>560</td>
              <td>720</td>
              <td>720</td>
              <td>720</td>
              <td>860</td>
              <td>860</td>
              <td>860</td>
              <td>1070</td>
              <td>1270</td>
            </tr>
            <tr>
              <td>H</td>
              <td>mm</td>
              <td>1545</td>
              <td>1545</td>
              <td>1595</td>
              <td>1645</td>
              <td>1645</td>
              <td>2000</td>
              <td>2050</td>
              <td>2070</td>
              <td>2210</td>
              <td>2210</td>
              <td>2250</td>
              <td>2350</td>
              <td>2350</td>
            </tr>
            <tr>
              <td>H1</td>
              <td>mm</td>
              <td>1325</td>
              <td>1325</td>
              <td>1375</td>
              <td>1425</td>
              <td>1425</td>
              <td>1740</td>
              <td>1790</td>
              <td>1820</td>
              <td>1995</td>
              <td>1995</td>
              <td>1995</td>
              <td>2230</td>
              <td>2230</td>
            </tr>
            <tr>
              <td>H2</td>
              <td>mm</td>
              <td>1170</td>
              <td>1170</td>
              <td>1210</td>
              <td>1260</td>
              <td>1240</td>
              <td>1541</td>
              <td>1591</td>
              <td>1616</td>
              <td>1768</td>
              <td>1768</td>
              <td>1768</td>
              <td>1992</td>
              <td>1967</td>
            </tr>
            <tr>
              <td>L</td>
              <td>mm</td>
              <td>1000</td>
              <td>1050</td>
              <td>1050</td>
              <td>1120</td>
              <td>1200</td>
              <td>1240</td>
              <td>1290</td>
              <td>1390</td>
              <td>1500</td>
              <td>1630</td>
              <td>1730</td>
              <td>1940</td>
              <td>2100</td>
            </tr>
            <tr>
              <td>L1</td>
              <td>mm</td>
              <td>680</td>
              <td>730</td>
              <td>730</td>
              <td>800</td>
              <td>880</td>
              <td>880</td>
              <td>930</td>
              <td>1030</td>
              <td>1100</td>
              <td>1230</td>
              <td>1330</td>
              <td>1490</td>
              <td>1650</td>
            </tr>
            <tr>
              <td>D</td>
              <td>mm</td>
              <td>159</td>
              <td>159</td>
              <td>178</td>
              <td>178</td>
              <td>219</td>
              <td>248</td>
              <td>248</td>
              <td>248</td>
              <td>298</td>
              <td>298</td>
              <td>298</td>
              <td>348</td>
              <td>398</td>
            </tr>
          </tbody>
          <thead>
            <tr>
              <th>Dimensiuni mecanizat</th>
              <th>U.M.</th>
              <th>21 kW</th>
              <th>27 kW</th>
              <th>33 kW</th>
              <th>40 kW</th>
              <th>50 kW</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>B</td>
              <td>mm</td>
              <td>680</td>
              <td>680</td>
              <td>730</td>
              <td>730</td>
              <td>730</td>
            </tr>
            <tr>
              <td>H</td>
              <td>mm</td>
              <td>1390</td>
              <td>1390</td>
              <td>1440</td>
              <td>1490</td>
              <td>1490</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};


